import { render, staticRenderFns } from "./MonthlySocsoExportParam.vue?vue&type=template&id=018ea9fa"
import script from "./MonthlySocsoExportParam.vue?vue&type=script&lang=js"
export * from "./MonthlySocsoExportParam.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports